import { Segmented } from 'antd';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  getAllPromptsListSlice,
  getPromptsByIdSlice,
} from 'src/modules/SuperAdmin/store/slices/prompts.slice';
import Promptspage from './Prompts.page';
import PromptOverridespage from '../PromptsOverride/PromptOverrides.page';
import { getFromStorage, storeInLocal } from '../../../../../../lib/storage';
import OrganizationFilter from '../OrganizationFilter';

const Prompts = ({ isMinimized }) => {
  const [activeButton, setActiveButton] = useState(() => {
    return getFromStorage('PromptsActiveSegment') || 'Prompts';
  });
  const dispatch = useDispatch();

  const PromptsButton = [
    {
      label: 'Prompts',
      isActive: activeButton === 'Prompts',
      onClick: () => setActiveButton('Prompts'),
    },
    {
      label: 'Prompt overrides',
      isActive: activeButton === 'Prompt overrides',
      onClick: () => setActiveButton('Prompts overrides'),
    },
  ];

  const handleSegmentedTabChange = (value) => {
    setActiveButton(value);
    dispatch(getPromptsByIdSlice(null));
    dispatch(getAllPromptsListSlice(null));
    storeInLocal('PromptsActiveSegment', value);
  };
  const shouldShowPrompts = activeButton !== 'Prompts';
  return (
    <div className={`page-wrapper`}>
      {shouldShowPrompts && (
        <OrganizationFilter shouldShowPrompts={shouldShowPrompts} />
      )}
      <div className="lg:flex gap-3 justify-between py-3 px-1 items-center ">
        <div className="lg:flex segmented_schedule  rounded-lg w-fit">
          <Segmented
            options={PromptsButton.map((button) => ({
              label: button.label,
              value: button.label,
            }))}
            value={activeButton}
            onChange={(value) => {
              handleSegmentedTabChange(value);
            }}
          />
        </div>
      </div>
      <div>
        {activeButton === 'Prompts' && (
          <>
            <Promptspage />
          </>
        )}
        {activeButton === 'Prompt overrides' && (
          <>
            <PromptOverridespage />
          </>
        )}
      </div>
    </div>
  );
};

export default Prompts;
